import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconPerson = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#333333",
		d: "M10 10c1.842 0 3.333-1.492 3.333-3.333 0-1.842-1.491-3.334-3.333-3.334S6.667 4.825 6.667 6.667C6.667 8.508 8.158 10 10 10zm0 1.667c-2.225 0-6.667 1.116-6.667 3.333v1.667h13.334V15c0-2.217-4.442-3.333-6.667-3.333z"
	})
});
export default SvgIconPerson;
